import React from "react";
import ProformaInvoices from "pages/ProformaInvoices";

// «سایر سفارش‌ها» همان نمای «همه سفارش‌ها» است با دو تفاوت:
//
//   ۱) دامنه: از اندپوینت اختصاصی GET /proforma-invoices/other-orders/ می‌خواند که
//      سفارش‌های همه‌ی کارشناسان فروش را برمی‌گرداند، شامل سفارش‌های خودِ کاربر.
//      («همه سفارش‌ها» برای کارشناس فروش فقط سفارش‌های خودش و کسانی را نشان می‌دهد
//      که مستقیماً جایگزین‌شان شده است.)
//   ۲) فقط‌خواندنی: همه‌ی عملیات ثبت، ویرایش، حذف، پرداخت، تأیید، برگشت و تغییر
//      وضعیت مخفی‌اند — حتی برای ردیف خود کاربر و حتی برای ادمین. فقط مشاهده،
//      فیلتر و خروجی اکسل باقی می‌ماند.
//
// فیلترها و صفحه‌بندی این اندپوینت دقیقاً مثل فهرست اصلی است.
const Index = () => (
  <ProformaInvoices
    pageTitle="سایر سفارش‌ها"
    totalLabel="مجموع سفارش‌ها"
    emptyText="هیچ سفارشی برای نمایش وجود ندارد"
    showCreateButton={false}
    orderStatus={null}
    section="otherOrders"
    listEndpoint="/proforma-invoices/other-orders/"
    readOnly
    showFilters
    showDateColumn
    mobileColumns={2}
  />
);

export default Index;
